import { render, staticRenderFns } from "./DownloadInvoicePdf.vue?vue&type=template&id=395fda4d"
import script from "./DownloadInvoicePdf.vue?vue&type=script&lang=js"
export * from "./DownloadInvoicePdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports